//
// DataGridPickResultEntry.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import ClosetObject from "../ClosetObject";
import "../lib";
import "../pickResults/PickResultEntry";
import "../pickResults/PickEntryType";

var DataGridPickResultEntry = createModule("commons::DataGridPickResultEntry", ["commons::PickResultEntry"], ClosetObject, [
    ,
    ,
    ,
    {
        sparkCell: 2,
        pickId: 4,
        columnIndex: 4,
        rowIndex: 4,
        type: 4,
        selected: 2,
        dropIndex: 4,
    },
    ,
    {
        _create: [4],
    },
    ,
]);
export default DataGridPickResultEntry;
